import React from 'react'
import { Map as MapContainer, TileLayer } from 'react-leaflet';

import { showDataOnMap } from '../util';
import "./Map.css"


const Map = ({ countries, caseType, center, zoom }) => {
  return (
    <div className="map">
      <MapContainer center={center} zoom={zoom}>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {showDataOnMap(countries, caseType)}
      </MapContainer>
    </div>
  )
}

export default Map;
